import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-section',{attrs:{"id":"info-alt","space":"0"}},[_c(VContainer,{staticClass:"mt-n16 mb-12"},[_c(VRow,{attrs:{"justify":"space-between"}},[_c(VCol,{attrs:{"cols":"12","md":"5"}},[_c('base-business-info',{attrs:{"title":"KEEP IN TOUCH WITH US"}},[_vm._v("\n          Your information is important to us.\n        ")])],1),_vm._v(" "),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c('base-contact-form',{attrs:{"title":"MAIL US YOUR MESSAGE"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }